import React from 'react'
import { Card, CardContent, IconButton, Typography, makeStyles } from '@material-ui/core'
import indigo from '@material-ui/core/colors/indigo'
import ChordCard from './ChordCard'

type ChordType = {
	symbol: string,
	notes: string[]
}

type ChordCategoryType = {
	name: string,
	chords: ChordType[]
}

const useStyles = makeStyles((theme) => ({
}))

const chordCategoryNames = ['2/3', '4', '5', '6+']

const getChordCategories = (chords: ChordType[]) => {
	const chordCategories = chordCategoryNames.map((categoryName): ChordCategoryType => ({
		name: categoryName,
		chords: []
	}))

	chords.forEach(chord => chordCategories[chord.notes.length <= 3 ? 0 : chord.notes.length === 4 ? 1 : chord.notes.length === 5 ? 2 : 3].chords.push(chord))

	return chordCategories.filter(chordCategory => chordCategory.chords.length > 0)
}

const ChordsSettings = (props: {
	chords: ChordType[],
	chord?: ChordType,
	onChordChange?: (chord: ChordType | undefined) => void,
	onPlayClick: (chord: ChordType) => void
}) => {

	const {
		chords,
		chord,
		onChordChange,
		onPlayClick
	} = props

	const classes = useStyles()

	chords.sort((c1, c2) => c1.notes.length < c2.notes.length ? -1 : 1)

	const chordCategories = getChordCategories(chords)

	return (
		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
			{chordCategories.map(chordCategory => (
				<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 24 }}>
					<Typography variant="h4" component="h2" style={{
						marginBottom: 6,
						color: 'white',
						padding: '0 64px 9px 64px',
						borderBottom: '1px solid white',
						fontSize: '1.125rem',	
					}}>
						{chordCategory.name + ' notes chords'}
					</Typography>
					
					<div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
						{chordCategory.chords.map(c => (
							<ChordCard
								selected={chord?.symbol === c.symbol}
								chord={c}
								onChange={onChordChange ? () => onChordChange(c === chord ? undefined : c) : undefined}
								onPlayClick={onPlayClick}
							/>
						))}
					</div>
				</div>
			))}
		</div>
	)
}

export default ChordsSettings

// ~TODO : onChordChange -> scrollTop
